import { render, staticRenderFns } from "./userTabs.vue?vue&type=template&id=23166a80"
import script from "./userTabs.vue?vue&type=script&lang=js"
export * from "./userTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports